import { render, staticRenderFns } from "./optionsChose.vue?vue&type=template&id=67837b5b&scoped=true&"
import script from "./optionsChose.vue?vue&type=script&lang=js&"
export * from "./optionsChose.vue?vue&type=script&lang=js&"
import style0 from "./optionsChose.vue?vue&type=style&index=0&id=67837b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67837b5b",
  null
  
)

export default component.exports